import { render, staticRenderFns } from "./SwitchControlModal.vue?vue&type=template&id=02026328&"
import script from "./SwitchControlModal.vue?vue&type=script&lang=js&"
export * from "./SwitchControlModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports